import React, { Component } from "react";
import { Alert, Button, Modal, Row, Popconfirm } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import WarningIcon from "./icon-warning.png";
import { deleteSelectedAssets } from "../../actions/ClientAction";
import WarningIcon from "../../assets/icons/warning-icon.svg";

class MultiDeleteModal extends Component {
  render() {
    const {
      showModal,
      handleHiddenModal,
      selectedFiles,
      isFetching,
      deleteSelectedAssets,
      workclient,
      keyCollection,
      intl,
      handleMultiDelete,
      items,
      folderName = "",
    } = this.props;

    const totalFiles =
      selectedFiles.length > 0 ? selectedFiles.length : items.length;
    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="delete-modal"
      >
        <div className="delete-modal-title">
          {intl.formatMessage({ id: "delete_asset" })}
        </div>
        <div
          style={{
            color: "#6F6F6F",
            fontSize: 18,
            fontWeight: 400,
            marginBottom: 10
          }}
        >
          {`${intl.formatMessage({
            id: "multi-delete-deleting"
          })} ${totalFiles} ${
            totalFiles === 1
              ? intl.formatMessage({ id: "multi-share-sharing-item" })
              : intl.formatMessage({ id: "multi-share-sharing-items" })
          }`}
        </div>

        <Alert
          showIcon
          type={"warning"}
          message={
            <span style={{ fontSize: 16, color: "#6F6F6F" }}>
              {intl.formatMessage({ id: "warning" })}
            </span>
          }
          description={
            items ? (
              <span>{intl.formatMessage({ id: "multi-delete-confirm" })}</span>
            ) : folderName ? (
              <span>
                {intl.formatMessage({ id: "multi-delete-reconfirm" })}/
                <b>{folderName}</b> 
              </span>
            ) : (
              <span>
                {intl.formatMessage({
                  id: "multi-delete-reconfirm-without-target"
                })}
              </span>
            )
            // ) : (
            //   <span>{`${intl.formatMessage({id: "multi-delete-reconfirm"})}/${folderName}`}</span>
            // )
          }
          // icon={<img src={WarningIcon} alt="icon warning" />}
          icon={
            <i
                aria-label="icon: exclamation-circle"
                className="anticon anticon-exclamation-circle ant-alert-icon"
              >
                <img
                  src={WarningIcon}
                  alt="warn"
                  className="delete-modal-warn-icon"
                />
              </i>
          }
        />

        <div style={{ marginTop: 24, fontSize: 18, marginBottom: 50 }}>
          {`${intl.formatMessage({ id: "multi-delete-delete" })} ${totalFiles}
          ${
            totalFiles === 1
              ? intl.formatMessage({ id: "multi-share-sharing-item" })
              : intl.formatMessage({ id: "multi-share-sharing-items" })
          }?`}
        </div>

        <Row type={"flex"} justify={"space-between"}>
          <Popconfirm
            title={
              `${intl.formatMessage({ id: "multi-delete-delete" })} ${totalFiles}
              ${
                totalFiles === 1
                  ? intl.formatMessage({ id: "multi-share-sharing-item" })
                  : intl.formatMessage({ id: "multi-share-sharing-items" })
              }?`}
            onConfirm={() => {
              if (handleMultiDelete) {
                handleMultiDelete();
                return;
              }
              if (selectedFiles.length > 0 && items === undefined) {
                const ids = selectedFiles.map(e => e._id);
                deleteSelectedAssets(keyCollection, workclient, ids, intl);
              } else if (items.length > 0 && items !== undefined) {
                deleteSelectedAssets(keyCollection, workclient, items, intl);
              }
            }}
            okText={intl.formatMessage({ id: "delete_asset" })}
            cancelText={intl.formatMessage({ id: "cancel_button" })}
          >
            <Button
              size={"large"}
              type={"primary"}
              className="delete-modal-button accept"
              // onClick={() => {
              //   if (handleMultiDelete) {
              //     handleMultiDelete();
              //     return;
              //   }
              //   if (selectedFiles.length > 0 && items === undefined) {
              //     const ids = selectedFiles.map(e => e._id);
              //     deleteSelectedAssets(keyCollection, workclient, ids, intl);
              //   } else if (items.length > 0 && items !== undefined) {
              //     deleteSelectedAssets(keyCollection, workclient, items, intl);
              //   }
              // }}
              loading={isFetching}
            >
              {intl.formatMessage({ id: "delete_asset" })}
            </Button>
          </Popconfirm>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="delete-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    selectedFiles: state.selectedFiles.data,
    keyCollection: state.selectedFiles.keyCollection,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  deleteSelectedAssets
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiDeleteModal))
);
